import React from 'react';

var LEGEND_ITEMS = [
  { status: 'available', label: 'Available', color: '#4CAF50' },
  { status: 'taken', label: 'Taken', color: '#9E9E9E' },
  { status: 'temporary_taken', label: 'Temporarily Held', color: '#7B1FA2' },
  { status: 'blocked', label: 'Blocked', color: '#212121', adminOnly: true },
  { status: 'selected', label: 'Selected', color: '#e8512f' },
  { status: 'first_come_first_serve', label: 'First Come First Serve', color: '#BDBDBD' }
];

class SeatLegend extends React.Component {
  renderPricingInfo() {
    var pricingTiers = this.props.pricingTiers || [];

    if (pricingTiers.length === 0) {
      return null;
    }

    return pricingTiers.map(function(tier, index) {
      var rows = tier.rows || [];
      var rowsText = '';

      if (rows.length > 2) {
        rowsText = 'Rows ' + rows[0] + '-' + rows[rows.length - 1] + ' Add-on:';
      } else if (rows.length > 0) {
        rowsText = 'Rows ' + rows.join(', ') + ' Add-on:';
      } else {
        rowsText = tier.name + ' Add-on:';
      }

      var addOn = tier.additionalPrice || 0;
      var priceText = '+$' + addOn;

      return (
        <div key={index} className="pricing-item">
          <span>{rowsText}</span>
          <span>{priceText}</span>
        </div>
      );
    });
  }

  render() {
    var showPricingInfo = this.props.showPricingInfo;
    var basePrice = this.props.basePrice || 0;
    var showFCFS = this.props.showFCFS !== false;
    var adminMode = this.props.adminMode;

    var filtered = LEGEND_ITEMS.filter(function(item) {
      if (!showFCFS && item.status === 'first_come_first_serve') { return false; }
      if (item.adminOnly && !adminMode) { return false; }
      return true;
    });

    var items = filtered.map(function(item) {
      if (item.status === 'first_come_first_serve' && adminMode) {
        return {
          status: item.status,
          label: item.label + ' ($' + basePrice + ')',
          color: item.color
        };
      }
      return item;
    });

    return (
      <div className="seat-legend">
        <div className="legend-title">Legend</div>
        {items.map(function(item, index) {
          var isFCFS = item.status === 'first_come_first_serve';
          return (
            <div key={index} className="legend-item">
              <div
                className="legend-color"
                style={{ backgroundColor: item.color, position: 'relative' }}
              >
                {isFCFS && (
                  <span style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', color: '#fff', fontSize: '12px', fontWeight: 'bold', lineHeight: 1 }}>&times;</span>
                )}
              </div>
              <span className="legend-label">{item.label}</span>
            </div>
          );
        })}
        {showPricingInfo && (
          <div className="pricing-info">
            <div className="pricing-title">Pricing</div>
            <div className="pricing-item base-price">
              <span>Base Price:</span>
              <span>${basePrice}</span>
            </div>
            {this.renderPricingInfo()}
          </div>
        )}
      </div>
    );
  }
}

export default SeatLegend;
